import React from 'react';
import { Modal, Form, Input } from 'antd';

const AddModal = ({ visible, title, onCancel, onAdd }) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    // Validar campos y mostrar sólo el mensaje de error en el Form.Item
    form.validateFields()
      .then(values => {
        onAdd(values);
        form.resetFields();
      })
      .catch(() => {
        // No hacemos nada: Ant Design mostrará el mensaje de validación
      });
  };

  return (
    <Modal
      visible={visible}
      title={title}
      onCancel={onCancel}
      onOk={handleOk}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="nombre"
          label="Nombre"
          rules={[{ required: true, message: 'Por favor ingresa el nombre' }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddModal;
